// extracted by mini-css-extract-plugin
module.exports = {"section":"QuoteSummary_section__1Z1Uz","plug":"QuoteSummary_plug__1MuuI"};